import { AccountVestingTypeEnum } from 'constants/vesting'
import { AccountVestingProvider } from 'context/account-vesting-context-provider'
import AccountVestingContent from 'modules/account-vesting/account-vesting-content'

import './style.scss'

const AccountVestingHMC = () => {
  return (
    <AccountVestingProvider type={AccountVestingTypeEnum.ACCOUNT_VESTING_HMC}>
      <AccountVestingContent title="Account Vesting HMC" />
    </AccountVestingProvider>
  )
}

export default AccountVestingHMC
